import { Inject, Injectable, InjectionToken } from '@angular/core';
import { Observable, firstValueFrom, from } from 'rxjs';
import { CacheService } from '../../utils/cache.service';
import { CommonSettings } from 'estensa-module';


export const ESTENSA_MODULE_COMMON_SETTINGS_SERVICE = new InjectionToken('estensa.module.common-settings.service');

export interface ICommonSettingsServiceNg1 {
    getAsJSON(): Promise<CommonSettings>;
    isExternalSigningEnabled(): boolean;
}

@Injectable({
    providedIn: 'root',
})
export class CommonSettingsService {

    private _commonSettings: CommonSettings | null = null;

    get commonSettings(): CommonSettings | null {
        return this._commonSettings;
    }

    get commonSettingsAsync(): Observable<CommonSettings> {
        return this.cacheService.get(
            'CommonSettings',
            from(this.settingsService.getAsJSON()),
        );
    }

    constructor(
        @Inject(ESTENSA_MODULE_COMMON_SETTINGS_SERVICE)
        private settingsService: ICommonSettingsServiceNg1,
        private cacheService: CacheService
    ) { }

    //getSettings(): Observable<any> {
    //    return this.cacheService.get(
    //        'CommonSettings',
    //        from(this.settingsService.getAsJSON()),
    //    );
    //}
    async initService() {
        if (this._commonSettings) {
            return this._commonSettings;
        }

        return firstValueFrom(this.commonSettingsAsync).then((settings) => {
            this._commonSettings = settings;
            return settings;
        });
    }

    isFeaEnabled(): boolean {
        return this.commonSettings?.feaSettings.isEnabled ?? false;
    }
}
